import { Nullable } from '@aibees/shared/definition';
import {
  convertMonthsToYearsAndMonths,
  intervalToDuration,
  intervalToDurationStrict,
  newDate,
} from '@aibees/shared/utils';

export function getJobDuration(
  start?: Nullable<string>,
  end?: Nullable<string>
) {
  if (!start) return;
  const startDate = newDate(start);
  const endDate = end ? newDate(end) : null;
  if (startDate) {
    const duration = endDate
      ? intervalToDurationStrict(startDate, endDate)
      : intervalToDuration(startDate);

    const { years, months } = convertMonthsToYearsAndMonths(
      (duration.months ?? 0) + (duration.years ?? 0) * 12
    );

    let formatedJobDuration = '';

    if (years) {
      formatedJobDuration = years + (years > 1 ? ' Years' : ' Year');
    }
    if (years && months) {
      formatedJobDuration += ', ';
    }
    if (months) {
      formatedJobDuration += months + (months > 1 ? ' Months' : ' Month');
    }

    return { years, months, fullText: formatedJobDuration };
  }
}
